import { API_DOMAIN } from "@monorepo/constants";
import { IVoucher } from "@monorepo/types";
import { createApi } from "@reduxjs/toolkit/query/react";

import { customBaseQuery } from "../../helpers/baseQuery";

export const vouchersApi = createApi({
  reducerPath: "vouchersApi",
  baseQuery: customBaseQuery({
    baseUrl: API_DOMAIN,
  }),
  tagTypes: ["Vouchers"],
  endpoints: (builder) => ({
    getMyVouchers: builder.query<Array<IVoucher>, void>({
      query: () => ({
        url: "/api/v1/gsm-vouchers",
      }),
      providesTags: ["Vouchers"],
    }),

    updateVoucher: builder.query<any, string>({
      query: (id) => ({
        url: `/api/v1/gsm-vouchers/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetMyVouchersQuery, useUpdateVoucherQuery } = vouchersApi;

export default vouchersApi.reducer;
